export const defaultDashboardSettings = {
  pvSettingID: null,
  pvAccountID: null,
  pvSettingType: '',
  pvSettingValue: '',
  pvVoid: 0,
  pvEntryDate: '',
  pvGlobalSetting: 0,
  pvGroupID: 0,
};

export const AccountInitialState: AccountTypes = {
  incidentSettings: null,
  account: null,
  selectedGroupName: null,
  selectedGroup: null,
  allGroups: null,
  dashboardSettings: defaultDashboardSettings,
  programsPermissions: null,
  error: null,
  isFetching: false,
  hasFetchedDashboardSettings: false,
};
